import React, { useState, useEffect, useRef } from "react";
import { motion, useScroll, useTransform, AnimatePresence } from "framer-motion";
import { 
  Calendar, Clock, MapPin, Plane, Users, Anchor, Star, 
  ChevronDown, ChevronLeft, ChevronRight, Play, Quote, Check, Circle, Menu, X,
  Sun, Waves, Heart, Sparkles, Ship, Phone, Mail, ExternalLink, FileText
} from "lucide-react";
import { toast } from "sonner";
import axios from "axios";

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Animation variants
const fadeUp = {
  initial: { opacity: 0, y: 40 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.8, ease: "easeOut" }
};

const staggerContainer = {
  animate: {
    transition: { staggerChildren: 0.1 }
  }
};

// URL de redirection pour FluentForm
const INSCRIPTION_URL = "https://gillesdelieuze.com/page-dinscription-voyage-mer-rouge-2026/";

// Fonction de redirection vers la page d'inscription
const redirectToInscription = () => {
  window.open(INSCRIPTION_URL, '_blank');
};

// Data - TOUS LES TÉMOIGNAGES EXACTS (sans emojis)
const testimonials = [
  {
    name: "Isabelle A.",
    photo: "https://gillesdelieuze.com/wp-content/uploads/2023/12/IMG_20230602_1322042.jpg",
    shortText: "Il y a un avant et un après... c'est indéniable.",
    fullText: "J'aimerais apporter mon témoignage en revenant sur cet incroyable voyage au pays des Dauphins et des Pyramides...\n\nIl était une fois un homme très inspirant de part plein d'aspects et notamment son empathie, ses partages et enseignements tous plus précieux les uns que les autres, j'ai nommé Gilles Delieuze.\n\nCet homme que je suis depuis plusieurs années, a eu la merveilleuse idée de créer ce voyage extraordinaire avec la complicité de Barbara d'Aora voyage.\n\nCe fût l'une des plus belles décisions que j'ai prise que d'oser m'offrir cette chance de le vivre malgré bien des freins... Et le bonheur fût à son comble quand mon fils a fait le choix de m'accompagner en sachant que l'on allait fêter ses 30 printemps en soufflant sur les pyramides !!!\n\nDepuis l'âge de 12 ans, où j'ai pu voir des dauphins libres pour la première fois, je me suis dit : « un jour je nagerai avec eux » !\n\nCe qui m'en reste est tellement au-delà de mes rêves les plus fous que les mots sont difficiles à trouver pour exprimer l'intensité de ces rencontres, de mes ressentis à chaque instant du voyage... Les maîtres Dauphins, comme une évidence, sont sans aucun doute les amis de Gilles dans ce que l'amitié représente de plus pur et de plus authentique.\n\nÊtre sur ce bateau, vivre 10 jours hors du temps, hors de tout, c'est être connecté à l'essentiel du beau, du grand, du profond, du coeur, de l'âme. C'est Être. Tout simplement.\n\nC'est vivre des rencontres humaines dans une bienveillance que l'on respire, que l'on boit, dont on s'habille...\n\nC'est un voyage au creux du soi qui vous enveloppe de merveilleux...\n\nIl y a un avant et un après... c'est indéniable.\n\nMon infinie gratitude à toi, Gilles d'être qui tu es. Je suis tellement heureuse de faire partie des personnes qui t'ont côtoyé dans ce contexte de rêve éveillé... privilégiée d'avoir reçu tes enseignements, ton accompagnement... je reviens tellement riche, tellement plus alignée et avec une ouverture du coeur et du corps inespérée.\n\nEt tu sais quoi ? J'en veux encore !!"
  },
  {
    name: "Nathalie",
    photo: "https://gillesdelieuze.com/wp-content/uploads/2023/05/nathalie-PINAUD.jpg",
    shortText: "6 mois après je shiftais 57 ans de vie parisienne.",
    fullText: "Le premier voyage avec les dauphins m'a permis de faire la paix avec mon aquaphobie en une semaine. Nager en leur compagnie m'a fait oublier le processus mental complexe de cette phobie. Tout est simple fluide pas de prise de tête hors du temps et de l'espace quand on nage à leurs côtés et l'accompagnement de Gilles permet d'ancrer ces nouvelles données.\n\nL'année suivante pour mon 2ème voyage, délivrée de mon appréhension de l'eau, j'ai pu intercepter très rapidement des messages délivrés par les dauphins - leur regard est très puissant - le principal : écouter ce qui me fait vibrer au plus profond de moi... La mer la chaleur la lumière.\n\n6 mois après je shiftais 57 ans de vie parisienne et je faisais le grand saut Paris / Perpignan peu importe comment j'allais mettre en place mes besoins vitaux. Cet emménagement serait juste.\n\nDepuis, il ne se passe pas un jour sans que je me remercie d'avoir osé tout en envoyant ma gratitude à Gilles et à ses fidèles dauphins. Un voyage transformateur."
  },
  {
    name: "Céline",
    photo: "https://gillesdelieuze.com/wp-content/uploads/2023/07/yoga-students2-1.png",
    shortText: "La plus belle expérience de ma vie.",
    fullText: "La plus belle expérience de ma vie. L'accompagnement de Gilles a magnifié cette rencontre que j'attendais depuis longtemps."
  },
  {
    name: "Hélène",
    photo: "https://gillesdelieuze.com/wp-content/uploads/2023/08/2_Home_Online_Training-Testimonials_3.jpg",
    shortText: "Il y a clairement un avant et un après.",
    fullText: "C'est une expérience très profonde, il y a clairement un avant et un après. Je le prenais en mode détente et je n'imaginais pas tout ce que j'allais connecter. Des prises de conscience majeures, une nouvelle Vie. Merci à Gilles pour la finesse de son accompagnement."
  },
  {
    name: "Simon",
    photo: "https://gillesdelieuze.com/wp-content/uploads/2023/08/2_Home_Online_Training-Testimonials_1.jpg",
    shortText: "Une profondeur et une reliance rare et précieuse.",
    fullText: "Un moment de Grâce renouvelé. Je les avais déjà rencontré mais voilà 3 fois que je repars avec Gilles car j'y trouve une profondeur et une reliance rare et précieuse."
  },
  {
    name: "Roseline",
    photo: "https://gillesdelieuze.com/wp-content/uploads/2023/12/IMG-20231008-WA0038.jpg",
    shortText: "Le meilleur voyage de ma vie tout simplement.",
    fullText: "Le meilleur voyage de ma vie tout simplement. J'y suis allée sans vraiment d'attente, seulement avec une envie de me dépasser mais je suis repartie avec tellement bien plus que je n'aurai jamais pu l'imaginer...\n\nJe vais faire de mon mieux pour décrire ce voyage même si ce n'est pas facile, une communion extraordinaire dans une baie remplie de Dauphins prêts à vous donner de l'Amour (préparez vous à vous reconnecter à votre Enfant Intérieur qui n'est que Joie), un groupe soudé et uni qui vous rappelle ce qu'est la vraie Humanité celle qu'on oublie parfois emporté par notre quotidien, et l'enseignement de Gilles comme pour lier ce Tout et mettre des mots sur ces sensations qu'on vit presque pour la première fois...\n\nGilles, dans toute sa bienveillance est celui qui vous \"poussera\" parfois à dépasser nos croyances limitantes parce qu'il aura su déceler en vous ce que vous êtes véritablement capable de faire et venu faire...\n\nUne Renaissance et une Gratitude infinie pour ce voyage qui m'a permis de me reconnecter à ces Instants d'Eternité à la fois si pures et si simples au final."
  },
  {
    name: "Virginie",
    photo: "https://gillesdelieuze.com/wp-content/uploads/2023/12/IMG_6504.jpeg",
    shortText: "Des instants de magie et communion d'une intensité rare.",
    fullText: "Trois Sataya déjà, au plus près des dauphins, de moi, accompagnée par toi Mr Gilles Delieuze et les groupes. Tellement de gratitude pour ce que je peux vivre, vibrer, ressentir là-bas.\n\nDes instants de magie, et communion d'une intensité rare, et pourtant j'ai déjà vécu mille vies en une par ailleurs, mais là-bas c'est un festival hors du temps, la sensation que tout se vit en accéléré.\n\nTa présence change tout, au-delà du lieu sacré et des animaux non moins sacrés de Sataya, tu nous y accompagnes avec joie intense et rectitude bienveillante. Le cadre que tu nous offres me convient parfaitement, secure et léger.\n\nJe ne comprends sûrement pas tout intellectuellement, mais je reviens chez moi toujours un peu changée, toujours plus libre des chaînes que je pourrais m'imposer au quotidien."
  },
  {
    name: "Hélène (Sataya Lover)",
    photo: "https://gillesdelieuze.com/wp-content/uploads/2023/12/566f956d-6506-4585-8354-e7bc1764834e.jpeg",
    shortText: "Une expérience sacrée guidée et amplifiée par Gilles.",
    fullText: "Partir nager avec les dauphins à Sataya peut paraître un rêve magique, une évasion bénie. En réalité, cet endroit est une capsule facilitante. Au contact d'êtres en cinq dimensions, divinement accompagné par leur Ambassadeur terrestre, Gilles Delieuze, vous découvrirez ce que ce rendez-vous vous réserve. Et c'est toujours plus grand, c'est toujours plus inclusif, c'est toujours plus naturellement humain."
  },
  {
    name: "Marlène",
    photo: "https://gillesdelieuze.com/wp-content/uploads/2023/12/68c220e0-0155-4f52-976f-527f142722bf.jpeg",
    shortText: "Une véritable retrouvaille, comme un retour à la maison originelle.",
    fullText: "Laissez-vous porter vers cette aventure merveilleuse. Un voyage hors du temps où les jours semblent des semaines. La rencontre avec les dauphins a été une véritable retrouvaille, comme un retour à la maison originelle. La joie, les pleurs, l'émerveillement m'ont envahi durant ce séjour et laissent une trace indélébile dans mon coeur. Merci à Gilles d'avoir fait de ce rêve une réalité bien au-delà de mes attentes."
  },
  {
    name: "Isabelle (Sataya Lover)",
    photo: "https://gillesdelieuze.com/wp-content/uploads/2023/12/68c220e0-0155-4f52-976f-527f142722bf.jpeg",
    shortText: "Bien plus que d'aller nager avec des dauphins.",
    fullText: "Bien plus que d'aller nager avec des dauphins, ou de réaliser un vieux rêve, il s'agit d'une RENCONTRE d'un autre type. Dans ces eaux matricielles, c'est à une expérience divinement humaine au coeur du ventre de Sataya que Gilles nous convie.\n\nÉvoluer avec ces Êtres tellement aimants et accueillants, tellement joyeux et enseignants. Une expérience sacrée guidée et amplifiée par la présence, l'attention, la bienveillance, et les mots de Gilles qui a su ouvrir un pont indéfinissable entre les deux mondes... Homo Delphinus...\n\nLe tout dans la simplicité, le rire et tant d'autres couleurs. Bref, la joie de chaque instant. À chacun de se choisir et de s'offrir un voyage de soi à Soi à travers le regard, la magie et la voie des dauphins.\n\nJ'en suis encore imprégnée à tous les niveaux, et à jamais. Merci Gilles, merci à chaque homme et chaque femme que j'ai eu le plaisir de rencontrer. Il y a un avant et un après, à n'en pas douter."
  }
];

// Photos dauphins - TOUTES LES PHOTOS
const dolphinImages = [
  "https://gillesdelieuze.com/wp-content/uploads/2024/10/snorkeler-with-dolphin-2023-11-27-05-14-46-utc-1-scaled.jpg",
  "https://gillesdelieuze.com/wp-content/uploads/2024/10/snorkeler-with-dolphin-2023-11-27-05-14-46-utc-scaled.jpg",
  "https://gillesdelieuze.com/wp-content/uploads/2024/10/dolphins-swimming-underwater-in-ocean-2023-11-27-05-34-01-utc-scaled.jpg",
  "https://gillesdelieuze.com/wp-content/uploads/2024/10/dolphins-swimming-underwater-2024-09-16-12-51-33-utc-scaled.jpg",
  "https://gillesdelieuze.com/wp-content/uploads/2024/10/atlantic-spotted-dolphin-stenella-frontalis-swi-2023-11-27-05-21-18-utc-scaled.jpeg",
  "https://gillesdelieuze.com/wp-content/uploads/2024/10/atlantic-spotted-dolphin-stenella-frontalis-swi-2023-11-27-05-21-09-utc-scaled.jpeg",
  "https://gillesdelieuze.com/wp-content/uploads/2024/10/a-majestic-pod-of-dolphins-gliding-through-the-dee-2024-07-08-18-45-07-utc-1-scaled.jpg",
  "https://gillesdelieuze.com/wp-content/uploads/2024/10/a-majestic-pod-of-dolphins-gliding-through-the-dee-2024-07-08-18-45-07-utc-scaled.jpg",
  "https://gillesdelieuze.com/wp-content/uploads/2024/10/dolphins-swimming-underwater-2023-11-27-05-30-26-utc-scaled.jpg",
  "https://gillesdelieuze.com/wp-content/uploads/2024/10/dolphins-swimming-underwater-in-ocean-2023-11-27-04-59-47-utc-scaled.jpg",
  "https://gillesdelieuze.com/wp-content/uploads/2023/04/Dauphins-Sataya-1-1024x676.png"
];

// Photos bateau - cabines, jacuzzi, salon, ponts
const boatImages = [
  "https://gillesdelieuze.com/wp-content/uploads/2023/11/bateau-egypte-2.jpeg",
  "https://gillesdelieuze.com/wp-content/uploads/2023/11/Lady-M_DJI_0219-scaled-1-1024x683.jpg",
  "https://gillesdelieuze.com/wp-content/uploads/2025/10/Hot-tub-WM-X3.jpg",
  "https://gillesdelieuze.com/wp-content/uploads/2025/10/RSAV-Yacht-Watermarked-M.jpg",
  "https://gillesdelieuze.com/wp-content/uploads/2025/10/Watermarked-GOPR4079-X3.jpg",
  "https://gillesdelieuze.com/wp-content/uploads/2024/10/669049176945440287bc97b66eaa6c3f.jpeg",
  "https://gillesdelieuze.com/wp-content/uploads/2024/10/01ce5b0a355675b0489248bdb2299b9b.jpeg",
  "https://gillesdelieuze.com/wp-content/uploads/2024/10/ed994e362266c7da2158ee607161f209-1.jpeg",
  "https://gillesdelieuze.com/wp-content/uploads/2024/10/3406c72938373aa0b50c6b1d218cc9b5.jpeg"
];

// Photos snorkeling et expérience
const snorkelingImages = [
  "https://gillesdelieuze.com/wp-content/uploads/2024/10/woman-snorkelling-underwater-with-snorkel-mask-in-2024-09-18-22-48-27-utc-scaled.jpg",
  "https://gillesdelieuze.com/wp-content/uploads/2024/10/adventurous-best-friends-taking-selfie-snorkeling-2024-07-03-02-44-05-utc-scaled.jpg",
  "https://gillesdelieuze.com/wp-content/uploads/2024/10/young-woman-snorkeling-in-tropical-water-on-vacati-2023-11-27-05-12-16-utc-scaled.jpg",
  "https://gillesdelieuze.com/wp-content/uploads/2024/10/snorkeling-woman-in-the-tropical-sea-2023-11-27-05-10-13-utc-scaled.jpg",
  "https://gillesdelieuze.com/wp-content/uploads/2024/10/snorkeling-woman-in-the-tropical-sea-2023-11-27-04-59-31-utc-scaled.jpg",
  "https://gillesdelieuze.com/wp-content/uploads/2024/10/underwater-view-of-couple-snorkeling-2023-11-27-05-13-20-utc-scaled.jpg",
  "https://gillesdelieuze.com/wp-content/uploads/2024/10/above-view-of-couple-snorkeling-in-blue-sea-water-2023-11-27-05-11-47-utc-scaled.jpg",
  "https://gillesdelieuze.com/wp-content/uploads/2024/10/unrecognizable-boy-snorkeling-in-mask-and-flippers-2023-11-27-05-08-45-utc-scaled.jpg",
  "https://gillesdelieuze.com/wp-content/uploads/2024/10/kid-snorkeling-in-australia-with-a-trigger-fish-2023-11-27-05-35-08-utc-scaled.jpg",
  "https://gillesdelieuze.com/wp-content/uploads/2024/10/a-guy-in-fins-and-a-mask-swims-in-a-lagoon-on-the-2023-11-27-04-51-25-utc-scaled.jpg"
];

// Toutes les photos pour la galerie
const galleryImages = [...dolphinImages, ...boatImages, ...snorkelingImages];

const faqData = [
  {
    question: "Je ne suis pas un bon nageur",
    answer: "Pas besoin d'être expert : le lagon est calme, la forte salinité vous permet de flotter sans effort. Les dauphins s'adaptent et viennent souvent au contact des nageurs plus lents. Vous êtes encadrés par des professionnels à chaque sortie."
  },
  {
    question: "Je n'ai pas le temps",
    answer: "Prendre du temps pour vous-même n'est pas un luxe, mais une nécessité. Ce voyage offre une parenthèse hors du quotidien, où vous pourrez vous ressourcer et revenir avec plus d'énergie et de clarté."
  },
  {
    question: "C'est un investissement important",
    answer: "Ce voyage est un investissement dans votre bien-être et votre développement personnel. Les bienfaits se répercuteront dans tous les aspects de votre vie. Vous pouvez échelonner le règlement pour le rendre plus accessible."
  },
  {
    question: "Je n'ai jamais médité",
    answer: "Gilles s'adapte à chaque participant et accompagne chacun avec bienveillance. Au travers d'outils ludiques et puissants, il vous amènera à contacter des sphères de votre conscience jusqu'alors inexplorées."
  },
  {
    question: "À partir de combien le voyage est validé ?",
    answer: "Un minimum de 14 personnes fermement inscrites sont nécessaires pour la tenue du voyage. Nous vous tenons informés de l'évolution des inscriptions."
  },
  {
    question: "Le matériel PMT est-il compris ?",
    answer: "Vous aurez sur le bateau des équipements loués pour la durée du séjour. Toutefois, si vous possédez votre propre matériel, vous pouvez l'amener pour un meilleur confort."
  },
  {
    question: "Cabine individuelle possible ?",
    answer: "Sous réserve de disponibilité, cette option est possible avec coûts en sus. Contactez-nous pour plus d'informations."
  }
];

// Components
const Navigation = ({ scrolled }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  
  const navLinks = [
    { href: "#infos", label: "Infos" },
    { href: "#programme", label: "Programme" },
    { href: "#temoignages", label: "Témoignages" },
    { href: "#tarifs", label: "Tarifs" },
    { href: "#faq", label: "FAQ" }
  ];

  return (
    <>
      <nav 
        className={`fixed top-0 left-0 right-0 z-[9999] transition-all duration-500 ${
          scrolled 
            ? 'bg-[#1E3A5F]/95 backdrop-blur-md py-4 shadow-lg' 
            : 'bg-transparent py-6'
        }`}
        data-testid="main-navigation"
      >
        <div className="max-w-7xl mx-auto px-6 flex justify-between items-center">
          <a href="#hero" className="flex items-center gap-3 group" data-testid="nav-logo">
            <Waves className="w-8 h-8 text-[#C9A962] group-hover:rotate-12 transition-transform" />
            <span className="font-['Playfair_Display'] text-xl font-semibold text-white">
              Sataya 2026
            </span>
          </a>
          
          <ul className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <li key={link.href}>
                <a 
                  href={link.href}
                  className="text-white/90 hover:text-[#C9A962] transition-colors text-sm font-medium tracking-wide"
                  data-testid={`nav-link-${link.label.toLowerCase()}`}
                >
                  {link.label}
                </a>
              </li>
            ))}
            <li>
              <button 
                onClick={redirectToInscription}
                className="relative bg-gradient-to-r from-[#C9A962] to-[#CD7F32] text-[#1E3A5F] px-7 py-2.5 rounded-full font-semibold overflow-hidden group btn-modern"
                data-testid="nav-cta-button"
              >
                <span className="relative z-10">Réserver</span>
              </button>
            </li>
          </ul>
          
          <button 
            className="md:hidden text-white p-2"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            data-testid="mobile-menu-toggle"
          >
            <Menu className="w-6 h-6" />
          </button>
        </div>
      </nav>

      {/* Mobile Menu */}
      <AnimatePresence>
        {mobileMenuOpen && (
          <motion.div 
            className="fixed inset-0 bg-[#1E3A5F]/98 backdrop-blur-xl z-[100] flex flex-col"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            data-testid="mobile-menu"
          >
            <div className="flex justify-between items-center p-6">
              <span className="font-['Playfair_Display'] text-xl text-white">Sataya 2026</span>
              <button onClick={() => setMobileMenuOpen(false)} className="text-white p-2">
                <X className="w-6 h-6" />
              </button>
            </div>
            <div className="flex-1 flex flex-col justify-center items-center gap-8">
              {navLinks.map((link) => (
                <a 
                  key={link.href}
                  href={link.href}
                  onClick={() => setMobileMenuOpen(false)}
                  className="text-white text-2xl font-['Playfair_Display'] hover:text-[#C9A962] transition-colors"
                >
                  {link.label}
                </a>
              ))}
              <button 
                onClick={() => { setMobileMenuOpen(false); redirectToInscription(); }}
                className="mt-8 bg-gradient-to-r from-[#C9A962] to-[#CD7F32] text-[#1E3A5F] px-10 py-4 rounded-full font-semibold text-lg"
              >
                Réserver ma place
              </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

const HeroSection = () => {
  return (
    <section id="hero" className="hero-video-container" data-testid="hero-section">
      {/* Animated Photo Background with Ken Burns effect */}
      <div className="absolute inset-0 overflow-hidden">
        <motion.img 
          src="https://gillesdelieuze.com/wp-content/uploads/2024/10/a-majestic-pod-of-dolphins-gliding-through-the-dee-2024-07-08-18-45-07-utc-1-scaled.jpg"
          alt="Dauphins Sataya"
          className="w-full h-full object-cover"
          initial={{ scale: 1 }}
          animate={{ scale: 1.1 }}
          transition={{ duration: 20, repeat: Infinity, repeatType: "reverse", ease: "linear" }}
        />
      </div>
      
      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#1E3A5F]/40 via-[#1E3A5F]/50 to-[#0F1E30]/90" />
      
      {/* Content */}
      <div className="hero-content">
        <motion.div 
          className="max-w-4xl"
          initial={{ opacity: 0, y: 60 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, ease: "easeOut" }}
        >
          <motion.span 
            className="inline-block px-6 py-2.5 rounded-full text-sm font-medium tracking-widest uppercase mb-8 bg-[#C9A962]/20 backdrop-blur-md border border-[#C9A962]/40 text-[#C9A962]"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.3 }}
            data-testid="hero-eyebrow"
          >
            Voyage Initiatique 2026
          </motion.span>
          
          <h1 className="text-5xl md:text-7xl lg:text-8xl font-bold text-white mb-6 tracking-tight leading-[0.95]" data-testid="hero-title">
            Communion avec les<br />
            <span className="text-gold-gradient">dauphins de Sataya</span>
          </h1>
          
          <p className="text-xl md:text-2xl text-[#C9A962] font-medium mb-8" data-testid="hero-subtitle">
            30 mai → 06 juin 2026 • 8 jours / 7 nuits • Mer Rouge, Égypte
          </p>
          
          <p className="text-lg md:text-xl text-white/90 max-w-2xl mx-auto mb-10 leading-relaxed font-light" data-testid="hero-text">
            Offre-toi une semaine en mer, loin du bruit. Du bleu à 360°, du silence, des rencontres vraies.
            Et surtout : <strong className="text-[#C9A962] font-semibold">un reset</strong> — du corps, du cœur, et de cette part de toi qui veut redevenir simple.
          </p>
          
          <div className="flex flex-wrap justify-center gap-4 mb-12">
            <a 
              href="#gilles"
              className="bg-[#C9A962]/15 backdrop-blur-md border border-[#C9A962]/30 px-5 py-3 rounded-full text-white/90 text-sm flex items-center gap-2 hover:bg-[#C9A962]/25 transition-all cursor-pointer" 
              data-testid="badge-expert"
            >
              <Star className="w-4 h-4 text-[#C9A962]" />
              Avec Gilles Delieuze (expert depuis 2007)
            </a>
            <span className="bg-[#C9A962]/15 backdrop-blur-md border border-[#C9A962]/30 px-5 py-3 rounded-full text-white/90 text-sm flex items-center gap-2" data-testid="badge-price">
              <Sparkles className="w-4 h-4 text-[#C9A962]" />
              Tarif : 2 590 €
            </span>
          </div>
          
          <div className="flex flex-wrap justify-center gap-5">
            <button 
              onClick={redirectToInscription}
              className="group relative bg-gradient-to-r from-[#C9A962] via-[#DCC67D] to-[#CD7F32] text-[#1E3A5F] px-10 py-4 rounded-full font-bold text-lg overflow-hidden btn-modern"
              data-testid="hero-cta-primary"
            >
              <span className="relative z-10">Je veux le dossier PDF</span>
            </button>
            <button 
              onClick={redirectToInscription}
              className="group relative border-2 border-[#C9A962]/70 text-white px-10 py-4 rounded-full font-semibold text-lg hover:bg-[#C9A962] hover:text-[#1E3A5F] transition-all duration-300"
              data-testid="hero-cta-secondary"
            >
              Je réserve ma place
            </button>
          </div>
        </motion.div>
      </div>
      
      {/* Scroll Indicator */}
      <div className="scroll-indicator">
        <p className="text-white/80 text-xs tracking-widest uppercase mb-3">Découvrir</p>
        <div className="scroll-mouse" />
      </div>
    </section>
  );
};

const StatsBar = () => {
  const stats = [
    { number: "18", label: "Années d'expérience" },
    { number: "200+", label: "Voyageurs transformés" },
    { number: "8", label: "Jours de communion" },
    { number: "100%", label: "Retours positifs" }
  ];

  return (
    <section className="bg-gradient-to-r from-[#1E3A5F] to-[#2D5A87] py-16" data-testid="stats-section">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12">
          {stats.map((stat, index) => (
            <motion.div 
              key={index}
              className="text-center"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              data-testid={`stat-item-${index}`}
            >
              <span className="block text-4xl md:text-5xl lg:text-6xl font-bold text-[#C9A962] font-['Playfair_Display'] mb-2">
                {stat.number}
              </span>
              <span className="text-white/80 text-sm md:text-base">{stat.label}</span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

const InfosSection = () => {
  const infos = [
    { icon: Calendar, label: "Dates", value: "30 mai → 06 juin 2026" },
    { icon: Clock, label: "Durée", value: "8 jours / 7 nuits" },
    { icon: MapPin, label: "Destination", value: "Baie de Sataya, Mer Rouge, Égypte" },
    { icon: Plane, label: "Accès", value: "Vols internationaux en option (départ Paris)" },
    { icon: Anchor, label: "Aéroport", value: "Marsa Alam (transferts inclus)" },
    { icon: Users, label: "Groupe", value: "Places limitées" },
    { icon: Waves, label: "Encadrement", value: "Snorkel guide & dive master professionnels" },
    { icon: Star, label: "Accompagnement", value: "Gilles Delieuze, expert communion dauphins" }
  ];

  return (
    <section id="infos" className="py-24 md:py-32 bg-gradient-to-b from-white to-[#FAFAF8]" data-testid="infos-section">
      <div className="max-w-7xl mx-auto px-6">
        <motion.div 
          className="text-center max-w-3xl mx-auto mb-16"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <span className="text-[#C9A962] text-sm font-semibold tracking-widest uppercase mb-4 block">Les essentiels</span>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#1E3A5F] mb-6">Infos pratiques</h2>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {infos.map((info, index) => (
            <motion.div 
              key={index}
              className="bg-white rounded-2xl p-6 shadow-sm hover:shadow-xl transition-all duration-500 card-hover border border-[#C9A962]/10 group"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.05 }}
              data-testid={`info-card-${index}`}
            >
              <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-[#C9A962]/10 to-[#CD7F32]/10 flex items-center justify-center mb-4 group-hover:from-[#C9A962] group-hover:to-[#CD7F32] transition-all duration-300">
                <info.icon className="w-7 h-7 text-[#C9A962] group-hover:text-white transition-colors" />
              </div>
              <p className="text-xs font-bold text-[#C9A962] uppercase tracking-wider mb-2">{info.label}</p>
              <p className="text-[#1E3A5F]/80 text-base leading-relaxed">{info.value}</p>
            </motion.div>
          ))}
        </div>

        <motion.p 
          className="text-center mt-10 text-sm text-[#1E3A5F]/60 italic bg-[#C9A962]/5 rounded-xl py-4 px-6 max-w-md mx-auto border border-[#C9A962]/10"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
        >
          Voyage validé à partir de 14 participants effectifs
        </motion.p>
      </div>
    </section>
  );
};

const PillarsSection = () => {
  const pillars = [
    { icon: Sparkles, title: "Quantic", desc: "Une approche quantique exclusive et inédite" },
    { icon: Heart, title: "Soul", desc: "Le supplément d'âme qui change tout" },
    { icon: Anchor, title: "Expert", desc: "Communion humain–dauphin depuis 2007" },
    { icon: Sun, title: "Joy", desc: "Humanisme, joie, conscience : une connexion inoubliable" }
  ];

  return (
    <section className="py-24 md:py-32 bg-white" data-testid="pillars-section">
      <div className="max-w-7xl mx-auto px-6">
        <motion.div 
          className="text-center max-w-3xl mx-auto mb-16"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <span className="text-[#C9A962] text-sm font-semibold tracking-widest uppercase mb-4 block">Notre signature</span>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#1E3A5F]">Pourquoi ce voyage est différent</h2>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {pillars.map((pillar, index) => (
            <motion.div 
              key={index}
              className="text-center p-8 rounded-3xl bg-gradient-to-b from-[#FAFAF8] to-white border border-[#C9A962]/10 hover:border-[#C9A962]/30 shadow-sm hover:shadow-xl transition-all duration-500 group"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              data-testid={`pillar-${index}`}
            >
              <div className="w-20 h-20 rounded-full bg-gradient-to-br from-[#C9A962]/15 to-[#CD7F32]/15 flex items-center justify-center mx-auto mb-6 group-hover:from-[#C9A962] group-hover:to-[#CD7F32] transition-all duration-500 group-hover:scale-110">
                <pillar.icon className="w-10 h-10 text-[#C9A962] group-hover:text-white transition-colors" />
              </div>
              <h3 className="text-2xl font-bold text-[#1E3A5F] mb-3">{pillar.title}</h3>
              <p className="text-[#1E3A5F]/70">{pillar.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

const StorySection = () => {
  return (
    <section className="py-24 md:py-32 bg-gradient-to-b from-[#1E3A5F] to-[#0F1E30] text-white" data-testid="story-section">
      <div className="max-w-4xl mx-auto px-6 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-8">L'appel du large. Le vrai.</h2>
          <p className="text-xl text-white/80 mb-6 leading-relaxed">
            Si tu sens que tu as besoin de respirer plus grand, ce voyage n'est pas un "trip".
          </p>
          <p className="text-xl text-white/80 mb-6 leading-relaxed">
            C'est une <strong className="text-[#C9A962]">capsule</strong> : tu coupes le bruit, tu retrouves ton rythme, tu redeviens lisible pour toi-même.
          </p>
          <p className="text-xl text-white/80 mb-6 leading-relaxed">
            Ici, tu ne viens pas "te réparer". Tu viens <strong className="text-[#C9A962]">te retrouver</strong>.
          </p>
        </motion.div>

        <motion.div 
          className="my-16 p-8 md:p-12 bg-white/5 backdrop-blur-md rounded-2xl border-l-4 border-[#C9A962] text-left"
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
        >
          <p className="text-2xl md:text-3xl font-['Cormorant_Garamond'] italic mb-4 leading-relaxed">
            « La vie, ce n'est pas seulement respirer. C'est aussi avoir le souffle coupé. »
          </p>
          <p className="text-white/70">— Alfred Hitchcock</p>
        </motion.div>

        <motion.a 
          href="#programme"
          className="inline-block bg-gradient-to-r from-[#C9A962] to-[#CD7F32] text-[#1E3A5F] px-10 py-4 rounded-full font-bold text-lg btn-modern"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          data-testid="story-cta"
        >
          Découvrir le programme
        </motion.a>
      </div>
    </section>
  );
};

const DestinationSection = () => {
  const features = [
    { icon: Waves, text: "Lagon calme et protégé" },
    { icon: Anchor, text: "Biodiversité exceptionnelle" },
    { icon: Sun, text: "Climat idéal en mai/juin" },
    { icon: Users, text: "Snorkeling accessible à tous" }
  ];

  return (
    <section id="destination" className="py-24 md:py-32 bg-white" data-testid="destination-section">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          <motion.div
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >
            <span className="text-[#C9A962] text-sm font-semibold tracking-widest uppercase mb-4 block">La destination</span>
            <h2 className="text-4xl md:text-5xl font-bold text-[#1E3A5F] mb-8">Baie de Sataya : la maison des dauphins</h2>
            
            <p className="text-lg text-[#1E3A5F]/80 mb-6 leading-relaxed">
              Sataya est un récif préservé au sud de l'Égypte : un havre où les dauphins viennent se reposer, jouer, socialiser.
            </p>
            <p className="text-lg text-[#1E3A5F]/80 mb-6 leading-relaxed">
              Le lagon est <strong>calme</strong>, la salinité aide à flotter : un cadre idéal, même si tu n'es pas un nageur "technique".
            </p>
            <p className="text-lg text-[#1E3A5F]/80 mb-8 leading-relaxed">
              Et au-delà des dauphins : récifs coralliens, tortues, raies, poissons multicolores, pieuvres...
            </p>

            <div className="grid grid-cols-2 gap-4">
              {features.map((feature, index) => (
                <div 
                  key={index}
                  className="flex items-center gap-3 p-4 bg-gradient-to-br from-[#C9A962]/5 to-[#CD7F32]/5 rounded-xl border border-[#C9A962]/15"
                  data-testid={`destination-feature-${index}`}
                >
                  <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-[#C9A962]/20 to-[#CD7F32]/20 flex items-center justify-center">
                    <feature.icon className="w-5 h-5 text-[#C9A962]" />
                  </div>
                  <span className="text-sm text-[#1E3A5F]/80 font-medium">{feature.text}</span>
                </div>
              ))}
            </div>
          </motion.div>

          <motion.div
            className="relative"
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >
            <div className="img-zoom rounded-3xl overflow-hidden shadow-2xl border border-[#C9A962]/10">
              <img 
                src="https://gillesdelieuze.com/wp-content/uploads/2023/11/Mer-Rouge-1024x680.png" 
                alt="Baie de Sataya, Mer Rouge"
                className="w-full h-[400px] object-cover"
              />
            </div>
            {/* Second smaller image */}
            <div className="absolute -bottom-8 -left-8 w-48 h-48 img-zoom rounded-2xl overflow-hidden shadow-xl border-4 border-white hidden lg:block">
              <img 
                src="https://gillesdelieuze.com/wp-content/uploads/2023/04/Dauphins-Sataya-1-1024x676.png" 
                alt="Dauphins Sataya"
                className="w-full h-full object-cover"
              />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

// Ethical Section
const EthicalSection = () => {
  return (
    <section className="py-20 md:py-28 bg-gradient-to-r from-[#C9A962]/5 via-[#DCC67D]/5 to-[#CD7F32]/5" data-testid="ethical-section">
      <div className="max-w-4xl mx-auto px-6">
        <motion.div 
          className="text-center"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <span className="text-[#C9A962] text-sm font-semibold tracking-widest uppercase mb-4 block">Notre éthique</span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#1E3A5F] mb-8">
            Une rencontre respectueuse. En conscience.
          </h2>
          <p className="text-lg text-[#1E3A5F]/80 leading-relaxed max-w-3xl mx-auto">
            On privilégie des rencontres <strong className="text-[#C9A962]">non intrusives</strong> : respect du rythme des dauphins, 
            observation depuis le bateau quand c'est juste, et présence à l'eau quand l'invitation existe. 
            Gilles vous permettra de vous connecter à la présence juste pour magnifier vos rencontres 
            dans le respect, la conscience et la communion réciproques.
          </p>
        </motion.div>
      </div>
    </section>
  );
};

const ProgrammeSection = () => {
  const timeline = [
    { time: "Matin", title: "Rencontre avec les dauphins", desc: "Sortie(s) en mer / dauphins, selon conditions et rythme du groupe. Petit déjeuner puis 2ème sortie." },
    { time: "12h30 - 13h00", title: "Déjeuner buffet", desc: "Repas copieux et convivial à bord." },
    { time: "Après-midi", title: "Temps libre & 3ème sortie", desc: "Sieste, nage, exploration ou repos. 3ème sortie en mer. Goûter vers 16h30." },
    { time: "Fin d'après-midi", title: "Enseignement avec Gilles", desc: "Cercle de partage et pratiques guidées (2h d'enseignements par jour)." },
    { time: "19h00 - 20h00", title: "Dîner & soirée", desc: "Buffet, puis partages, jeux, musique, repos. Possibilité de dormir à la belle étoile." },
    { time: "Jour 8", title: "Retour", desc: "Départ de Sataya → port → transfert aéroport → vol retour (vol non inclus)" }
  ];

  return (
    <section id="programme" className="py-24 md:py-32 bg-[#FAFAF8]" data-testid="programme-section">
      <div className="max-w-4xl mx-auto px-6">
        <motion.div 
          className="text-center max-w-3xl mx-auto mb-16"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <span className="text-[#C9A962] text-sm font-semibold tracking-widest uppercase mb-4 block">Votre journée</span>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#1E3A5F] mb-6">Programme & rythme</h2>
          <p className="text-lg text-[#1E3A5F]/70">
            Le cadre est clair. L'expérience est vivante. Chaque jour : sorties dans le lagon, intégration, pratiques guidées, temps libres.
            <br /><strong className="text-[#1E3A5F]">Tu viens te déposer, pas te sur-optimiser.</strong>
          </p>
        </motion.div>

        <div className="relative pl-8 md:pl-12">
          <div className="timeline-line" />
          
          {timeline.map((item, index) => (
            <motion.div 
              key={index}
              className="relative mb-8 last:mb-0"
              initial={{ opacity: 0, x: 20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              data-testid={`timeline-item-${index}`}
            >
              <div className="timeline-dot" />
              <div className="bg-white rounded-2xl p-6 md:p-8 shadow-lg hover:shadow-xl transition-all ml-4 border border-gray-100/80">
                <span className="inline-block bg-gradient-to-r from-[#1E3A5F] to-[#2D5A87] text-white px-4 py-1.5 rounded-full text-xs font-semibold mb-3">
                  {item.time}
                </span>
                <h3 className="text-xl font-bold text-[#1E3A5F] mb-2">{item.title}</h3>
                <p className="text-[#1E3A5F]/70">{item.desc}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

const BoatSection = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % boatImages.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="py-24 md:py-32 bg-white" data-testid="boat-section">
      <div className="max-w-7xl mx-auto px-6">
        <motion.div 
          className="text-center max-w-3xl mx-auto mb-16"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <span className="text-[#C9A962] text-sm font-semibold tracking-widest uppercase mb-4 block">Votre hebergement</span>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#1E3A5F] mb-6">Un sejour confortable a bord</h2>
          <p className="text-lg text-[#1E3A5F]/70">
            Bateau tout confort de 39 metres, 15 cabines climatisees avec salle de bain privative, espaces de detente ombrages, pont panoramique, jacuzzi, bar avec boissons a volonte...
          </p>
        </motion.div>

        {/* Main Carousel - SANS TEXTE */}
        <div className="relative rounded-3xl overflow-hidden shadow-2xl mb-8">
          <motion.div 
            className="flex"
            animate={{ x: `-${currentSlide * 100}%` }}
            transition={{ duration: 0.8, ease: "easeInOut" }}
          >
            {boatImages.map((img, index) => (
              <div key={index} className="w-full flex-shrink-0">
                <img 
                  src={img} 
                  alt=""
                  className="w-full h-[400px] md:h-[500px] object-cover"
                />
              </div>
            ))}
          </motion.div>
          
          {/* Navigation dots */}
          <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex gap-2">
            {boatImages.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentSlide(index)}
                className={`w-3 h-3 rounded-full transition-all ${
                  index === currentSlide ? 'bg-[#C9A962] scale-125' : 'bg-white/50 hover:bg-white/80'
                }`}
                data-testid={`boat-dot-${index}`}
              />
            ))}
          </div>
        </div>

        {/* Thumbnails */}
        <div className="grid grid-cols-3 md:grid-cols-9 gap-3">
          {boatImages.map((img, index) => (
            <motion.button
              key={index}
              onClick={() => setCurrentSlide(index)}
              className={`rounded-xl overflow-hidden transition-all ${
                index === currentSlide ? 'ring-4 ring-[#C9A962]' : 'opacity-60 hover:opacity-100'
              }`}
              whileHover={{ scale: 1.05 }}
              data-testid={`boat-thumb-${index}`}
            >
              <img src={img} alt="" className="w-full h-16 md:h-20 object-cover" />
            </motion.button>
          ))}
        </div>

        {/* Equipements */}
        <motion.div 
          className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-4"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          {[
            "15 cabines climatisees",
            "Salles de bain privatives",
            "Pont panoramique",
            "Jacuzzi",
            "Espaces detente ombrages",
            "Bar a volonte",
            "Acces facile a la mer",
            "Equipage attentionne"
          ].map((item, index) => (
            <div key={index} className="bg-[#FAFAF8] rounded-xl p-4 text-center border border-[#C9A962]/10">
              <Check className="w-5 h-5 text-[#C9A962] mx-auto mb-2" />
              <span className="text-[#1E3A5F]/80 text-sm">{item}</span>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

const TestimonialsSection = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const [expandedTestimonial, setExpandedTestimonial] = useState(null);
  
  useEffect(() => {
    if (isPaused || expandedTestimonial !== null) return;
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % testimonials.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [isPaused, expandedTestimonial]);

  return (
    <section id="temoignages" className="py-24 md:py-32 bg-gradient-to-b from-[#FAFAF8] to-white" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-6">
        <motion.div 
          className="text-center max-w-3xl mx-auto mb-16"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <span className="text-[#C9A962] text-sm font-semibold tracking-widest uppercase mb-4 block">Ils témoignent</span>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#1E3A5F] mb-6">Ils en parlent mieux que moi</h2>
          <p className="text-lg text-[#1E3A5F]/70">
            Ce qui revient le plus : "il y a un avant et un après".
            <br />Et souvent... des bascules très concrètes (peurs, confiance, choix de vie, paix intérieure).
          </p>
        </motion.div>

        {/* First Video Testimonial */}
        <motion.div 
          className="video-embed mb-12 shadow-2xl max-w-4xl mx-auto rounded-2xl overflow-hidden"
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
        >
          <iframe 
            src="https://www.youtube.com/embed/Ny3FHPt0tKY" 
            title="Témoignage vidéo 1"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
            allowFullScreen
            data-testid="testimonial-video-1"
          />
        </motion.div>

        {/* Testimonials Carousel */}
        <div 
          className="relative mb-12"
          onMouseEnter={() => setIsPaused(true)}
          onMouseLeave={() => setIsPaused(false)}
        >
          <div className="overflow-hidden">
            <motion.div 
              className="flex"
              animate={{ x: `-${currentIndex * 100}%` }}
              transition={{ duration: 0.7, ease: "easeInOut" }}
            >
              {testimonials.map((testimonial, index) => (
                <div 
                  key={index}
                  className="w-full flex-shrink-0 px-4"
                  data-testid={`testimonial-card-${index}`}
                >
                  <div className="max-w-3xl mx-auto bg-white rounded-3xl p-8 md:p-12 shadow-lg border border-[#C9A962]/10 testimonial-card">
                    <p className="text-lg md:text-xl text-[#1E3A5F]/80 font-['Cormorant_Garamond'] italic leading-relaxed mb-6">
                      "{testimonial.shortText}"
                    </p>
                    <button 
                      onClick={() => setExpandedTestimonial(index)}
                      className="text-[#C9A962] font-semibold text-sm hover:text-[#CD7F32] transition-colors mb-6 flex items-center gap-2"
                    >
                      Lire le témoignage complet
                      <ChevronDown className="w-4 h-4" />
                    </button>
                    <div className="flex items-center gap-4">
                      <img 
                        src={testimonial.photo} 
                        alt={testimonial.name}
                        className="w-16 h-16 rounded-full object-cover border-2 border-[#C9A962]"
                      />
                      <div>
                        <p className="text-[#1E3A5F] font-semibold text-lg">{testimonial.name}</p>
                        <p className="text-[#C9A962] text-sm">Voyageuse Sataya</p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </motion.div>
          </div>

          {/* Dots */}
          <div className="flex justify-center gap-3 mt-8">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentIndex(index)}
                className={`w-3 h-3 rounded-full transition-all ${
                  index === currentIndex 
                    ? 'bg-gradient-to-r from-[#C9A962] to-[#CD7F32] scale-125' 
                    : 'bg-[#1E3A5F]/20 hover:bg-[#C9A962]/50'
                }`}
                data-testid={`testimonial-dot-${index}`}
              />
            ))}
          </div>
        </div>

        {/* Second Video Testimonial */}
        <motion.div 
          className="video-embed shadow-2xl max-w-4xl mx-auto rounded-2xl overflow-hidden"
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
        >
          <iframe 
            src="https://www.youtube.com/embed/-cRRcREmHHA" 
            title="Témoignage vidéo 2"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
            allowFullScreen
            data-testid="testimonial-video-2"
          />
        </motion.div>
      </div>

      {/* Expanded Testimonial Modal */}
      <AnimatePresence>
        {expandedTestimonial !== null && (
          <motion.div 
            className="fixed inset-0 bg-[#1E3A5F]/80 backdrop-blur-md z-[1000] flex items-center justify-center p-4"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setExpandedTestimonial(null)}
          >
            <motion.div 
              className="bg-white rounded-3xl p-8 md:p-12 max-w-2xl w-full relative shadow-2xl"
              initial={{ scale: 0.95, y: 20 }}
              animate={{ scale: 1, y: 0 }}
              exit={{ scale: 0.95, y: 20 }}
              onClick={(e) => e.stopPropagation()}
            >
              <button 
                onClick={() => setExpandedTestimonial(null)}
                className="absolute top-6 right-6 w-10 h-10 rounded-full bg-[#FAFAF8] flex items-center justify-center hover:bg-[#C9A962] hover:text-white transition-all"
              >
                <X className="w-5 h-5" />
              </button>
              
              <div className="flex items-center gap-4 mb-6">
                <img 
                  src={testimonials[expandedTestimonial].photo} 
                  alt={testimonials[expandedTestimonial].name}
                  className="w-20 h-20 rounded-full object-cover border-3 border-[#C9A962]"
                />
                <div>
                  <p className="text-[#1E3A5F] font-bold text-xl">{testimonials[expandedTestimonial].name}</p>
                  <p className="text-[#C9A962]">Voyageuse Sataya</p>
                </div>
              </div>
              
              <p className="text-lg text-[#1E3A5F]/80 font-['Cormorant_Garamond'] italic leading-relaxed">
                "{testimonials[expandedTestimonial].fullText}"
              </p>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </section>
  );
};

const GallerySection = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % galleryImages.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="py-24 md:py-32 bg-[#FAFAF8]" data-testid="gallery-section">
      <div className="max-w-7xl mx-auto px-6">
        <motion.div 
          className="text-center max-w-3xl mx-auto mb-16"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <span className="text-[#C9A962] text-sm font-semibold tracking-widest uppercase mb-4 block">Galerie</span>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#1E3A5F]">Moments de grâce</h2>
        </motion.div>

        {/* Main carousel */}
        <div className="relative rounded-3xl overflow-hidden shadow-2xl mb-8">
          <motion.div 
            className="flex"
            animate={{ x: `-${currentSlide * 100}%` }}
            transition={{ duration: 0.8, ease: "easeInOut" }}
          >
            {galleryImages.map((img, index) => (
              <div key={index} className="w-full flex-shrink-0">
                <img 
                  src={img} 
                  alt={`Galerie ${index + 1}`}
                  className="w-full h-[400px] md:h-[500px] object-cover"
                />
              </div>
            ))}
          </motion.div>
          
          {/* Navigation dots */}
          <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex gap-2">
            {galleryImages.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentSlide(index)}
                className={`w-3 h-3 rounded-full transition-all ${
                  index === currentSlide ? 'bg-[#C9A962] scale-125' : 'bg-white/50'
                }`}
                data-testid={`gallery-dot-${index}`}
              />
            ))}
          </div>
        </div>

        {/* Thumbnails */}
        <div className="grid grid-cols-3 md:grid-cols-6 gap-4">
          {galleryImages.map((img, index) => (
            <motion.button
              key={index}
              onClick={() => setCurrentSlide(index)}
              className={`rounded-xl overflow-hidden transition-all ${
                index === currentSlide ? 'ring-4 ring-[#C9A962]' : 'opacity-60 hover:opacity-100'
              }`}
              whileHover={{ scale: 1.05 }}
              data-testid={`gallery-thumb-${index}`}
            >
              <img src={img} alt="" className="w-full h-20 object-cover" />
            </motion.button>
          ))}
        </div>
      </div>
    </section>
  );
};

// PDF Viewer Section - Liseuse integree du dossier voyage
const PDFViewerSection = () => {
  const pdfUrl = "https://gillesdelieuze.com/wp-content/uploads/2025/10/Proposition-Egypte-V2-Gilles_compressed.pdf";
  const googleViewerUrl = `https://docs.google.com/viewer?url=${encodeURIComponent(pdfUrl)}&embedded=true`;
  
  return (
    <section id="dossier" className="py-24 md:py-32 bg-gradient-to-b from-white to-[#FAFAF8]" data-testid="pdf-viewer-section">
      <div className="max-w-6xl mx-auto px-6">
        <motion.div 
          className="text-center max-w-3xl mx-auto mb-12"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <span className="text-[#C9A962] text-sm font-semibold tracking-widest uppercase mb-4 block">
            Dossier complet
          </span>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#1E3A5F] mb-6">
            Consultez la presentation
          </h2>
          <p className="text-lg text-[#1E3A5F]/70">
            Feuilletez le dossier voyage complet avec toutes les informations : programme detaille, photos, hebergement et tarifs.
          </p>
        </motion.div>

        <motion.div 
          className="bg-white rounded-3xl shadow-2xl overflow-hidden border border-[#C9A962]/20"
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
        >
          {/* PDF Embed - Google Docs Viewer */}
          <div className="relative bg-[#f0f0f0]">
            <div className="h-[500px] md:h-[700px]">
              <iframe
                src={googleViewerUrl}
                className="w-full h-full border-0"
                title="Dossier Voyage Sataya 2026"
                data-testid="pdf-embed"
                allowFullScreen
              />
            </div>
          </div>
          
          {/* Actions Bar */}
          <div className="p-4 md:p-6 bg-gradient-to-r from-[#1E3A5F] to-[#2D5A87] flex flex-col items-center gap-4">
            <div className="flex items-center gap-3 text-white text-center md:text-left">
              <FileText className="w-5 h-5 md:w-6 md:h-6 text-[#C9A962]" />
              <span className="font-medium text-sm md:text-base">Dossier Voyage Dauphins Sataya 2026</span>
            </div>
            <div className="flex flex-col sm:flex-row gap-3 w-full sm:w-auto">
              <a 
                href={pdfUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-white/10 hover:bg-white/20 text-white px-5 py-2.5 rounded-full font-medium transition-all flex items-center justify-center gap-2 text-sm md:text-base"
                data-testid="view-fullscreen"
              >
                <ExternalLink className="w-4 h-4" />
                Plein ecran
              </a>
              <a 
                href={pdfUrl}
                download="Voyage-Sataya-2026.pdf"
                className="bg-white/10 hover:bg-white/20 text-white px-5 py-2.5 rounded-full font-medium transition-all flex items-center justify-center gap-2 text-sm md:text-base"
                data-testid="download-pdf"
              >
                <FileText className="w-4 h-4" />
                Telecharger
              </a>
              <button 
                onClick={redirectToInscription}
                className="bg-gradient-to-r from-[#C9A962] to-[#CD7F32] text-[#1E3A5F] px-5 py-2.5 rounded-full font-semibold hover:shadow-lg transition-all text-sm md:text-base"
                data-testid="inscription-btn"
              >
                Je m'inscris
              </button>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

const PricingSection = () => {
  return (
    <section id="tarifs" className="py-24 md:py-32 bg-gradient-to-b from-[#1E3A5F] to-[#0F1E30]" data-testid="pricing-section">
      <div className="max-w-7xl mx-auto px-6">
        <motion.div 
          className="text-center mb-16"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white">Tarif & réservation</h2>
        </motion.div>

        <motion.div 
          className="max-w-2xl mx-auto bg-white/5 backdrop-blur-xl rounded-3xl p-10 md:p-14 text-center pricing-glow"
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
        >
          <p className="text-7xl md:text-8xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-[#C9A962] to-[#CD7F32] font-['Playfair_Display'] mb-4" data-testid="price-amount">
            2 590 €
          </p>
          <p className="text-white/80 text-lg mb-8">par personne (hors vols internationaux)</p>

          <div className="bg-white/10 rounded-2xl p-6 mb-8 border border-white/10">
            <p className="text-white font-semibold mb-2">Paiement :</p>
            <p className="text-white/80">50% à la signature du contrat, puis 50% à J-60</p>
            <p className="text-[#C9A962] mt-3 font-medium">Échéancier possible</p>
          </div>

          <div className="flex flex-col gap-4">
            <button 
              onClick={redirectToInscription}
              className="w-full bg-gradient-to-r from-[#C9A962] via-[#DCC67D] to-[#CD7F32] text-[#1E3A5F] px-8 py-4 rounded-full font-bold text-lg btn-modern"
              data-testid="pricing-cta-primary"
            >
              Je réserve ma place
            </button>
            <button 
              onClick={redirectToInscription}
              className="w-full border border-white/40 text-white px-8 py-4 rounded-full font-semibold hover:bg-white/10 transition-all"
              data-testid="pricing-cta-secondary"
            >
              Je veux le dossier PDF
            </button>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

const InclusionSection = () => {
  const included = [
    "7 nuits à bord (cabine twin/double à partager)",
    "Bateau + équipage (+ snorkel guide/dive master)",
    "Pension complète",
    "Snacks + boissons non alcoolisées à volonté",
    "Encadrement des sorties en zodiac dans le lagon",
    "3 sorties quotidiennes en conscience avec les dauphins",
    "2h d'enseignements & pratiques par jour",
    "Transferts A/R minibus privatisés",
    "Accompagnement & enseignements de Gilles Delieuze"
  ];

  const excluded = [
    "Vol international A/R (non inclus – nous consulter)",
    "Boissons alcoolisées et dépenses personnelles",
    "Services / repas non mentionnés au programme",
    "Pourboires (~100€ / personne en moyenne)",
    "Visa égyptien à l'arrivée : 25 USD ou 25€",
    "Équipement snorkeling",
    "Plongées éventuelles (baptême/brevet)",
    "Assurance multirisque éventuelle"
  ];

  return (
    <section className="py-24 md:py-32 bg-white" data-testid="inclusion-section">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-8">
          <motion.div 
            className="bg-[#FAFAF8] rounded-3xl p-8 md:p-10 border border-[#1E3A5F]/10"
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >
            <h3 className="text-2xl font-bold text-[#1E3A5F] mb-6 flex items-center gap-3">
              <Check className="w-6 h-6 text-[#C9A962]" />
              Ce prix inclut
            </h3>
            <ul className="custom-bullet space-y-3">
              {included.map((item, index) => (
                <li key={index} className="text-[#1E3A5F]/80" data-testid={`included-item-${index}`}>
                  {item}
                </li>
              ))}
            </ul>
          </motion.div>

          <motion.div 
            className="bg-[#FAFAF8] rounded-3xl p-8 md:p-10 border border-[#1E3A5F]/10"
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >
            <h3 className="text-2xl font-bold text-[#1E3A5F] mb-6 flex items-center gap-3">
              <Circle className="w-6 h-6 text-[#1E3A5F]/50" />
              Le prix ne comprend pas
            </h3>
            <ul className="custom-bullet excluded space-y-3">
              {excluded.map((item, index) => (
                <li key={index} className="text-[#1E3A5F]/70" data-testid={`excluded-item-${index}`}>
                  {item}
                </li>
              ))}
            </ul>
          </motion.div>
        </div>

        <motion.p 
          className="text-center mt-10 text-sm text-[#1E3A5F]/60 italic"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
        >
          Voyage validé à compter de 14 participants effectifs
        </motion.p>
      </div>
    </section>
  );
};

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <section id="faq" className="py-24 md:py-32 bg-[#FAFAF8]" data-testid="faq-section">
      <div className="max-w-4xl mx-auto px-6">
        <motion.div 
          className="text-center max-w-3xl mx-auto mb-16"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <span className="text-[#C9A962] text-sm font-semibold tracking-widest uppercase mb-4 block">Vos questions</span>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#1E3A5F]">Questions fréquentes</h2>
        </motion.div>

        <div className="space-y-4">
          {faqData.map((faq, index) => (
            <motion.div 
              key={index}
              className="bg-white rounded-2xl overflow-hidden shadow-md border border-[#1E3A5F]/10"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.05 }}
              data-testid={`faq-item-${index}`}
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex justify-between items-center p-6 text-left hover:bg-[#FAFAF8] transition-colors"
                data-testid={`faq-question-${index}`}
              >
                <span className="text-lg font-semibold text-[#1E3A5F] pr-4">{faq.question}</span>
                <div className={`w-8 h-8 rounded-full bg-gradient-to-br from-[#C9A962] to-[#CD7F32] flex items-center justify-center flex-shrink-0 transition-transform ${
                  openIndex === index ? 'rotate-45' : ''
                }`}>
                  <span className="text-[#1E3A5F] text-xl font-bold">+</span>
                </div>
              </button>
              <AnimatePresence>
                {openIndex === index && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: "auto", opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.3 }}
                    className="overflow-hidden"
                  >
                    <p className="px-6 pb-6 text-[#1E3A5F]/70 leading-relaxed" data-testid={`faq-answer-${index}`}>
                      {faq.answer}
                    </p>
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

const GillesSection = () => {
  return (
    <section id="gilles" className="py-24 md:py-32 bg-white" data-testid="gilles-section">
      <div className="max-w-6xl mx-auto px-6">
        <div className="grid md:grid-cols-5 gap-12 items-center">
          <motion.div 
            className="md:col-span-2 img-zoom rounded-3xl overflow-hidden shadow-2xl"
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >
            <img 
              src="https://gillesdelieuze.com/wp-content/uploads/2023/07/IMG_9885_www.vincentphotographie.com_-1024x683.jpg" 
              alt="Gilles Delieuze"
              className="w-full h-[450px] object-cover"
            />
          </motion.div>
          
          <motion.div 
            className="md:col-span-3"
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >
            <span className="text-[#C9A962] text-sm font-semibold tracking-widest uppercase mb-4 block">Votre accompagnant</span>
            <h2 className="text-4xl md:text-5xl font-bold text-[#1E3A5F] mb-6">Gilles Delieuze</h2>
            
            <p className="text-lg text-[#1E3A5F]/80 mb-4 leading-relaxed">
              Mentor, enseignant, auteur et thérapeute depuis 25 ans en spiritualité incarnée, développement personnel et leadership.
            </p>
            <p className="text-lg text-[#1E3A5F]/80 mb-4 leading-relaxed">
              J'accompagne les êtres à changer de regard, à se pacifier avec l'existence et à révéler leur plein potentiel.
            </p>
            <p className="text-lg text-[#1E3A5F]/80 mb-8 leading-relaxed">
              Expert de la communion humain-dauphin depuis 2007, j'ai développé une approche unique basée sur la conscience quantique et le respect profond du vivant.
            </p>

            <a 
              href="https://gillesdelieuze.com/a-propos/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-gradient-to-r from-[#C9A962] to-[#CD7F32] text-white px-8 py-4 rounded-full font-semibold hover:shadow-lg transition-all btn-modern"
              data-testid="gilles-cta"
            >
              En savoir plus
              <ExternalLink className="w-4 h-4" />
            </a>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

const FinalCTASection = () => {
  return (
    <section className="py-24 md:py-32 bg-gradient-to-b from-[#1E3A5F] to-[#0F1E30] relative overflow-hidden" data-testid="final-cta-section">
      {/* Decorative elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-[#C9A962]/5 rounded-full blur-3xl" />
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-[#C9A962]/5 rounded-full blur-3xl" />
      
      <div className="max-w-4xl mx-auto px-6 text-center relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6">
            Prêt(e) à vivre cette expérience unique ?
          </h2>
          <p className="text-xl text-white/80 mb-10 max-w-2xl mx-auto">
            Plus que quelques places disponibles pour mai 2026.
            <br />Rejoignez-nous pour 8 jours qui changeront votre vie.
          </p>
          
          <div className="flex flex-wrap justify-center gap-5">
            <button 
              onClick={redirectToInscription}
              className="bg-gradient-to-r from-[#C9A962] via-[#DCC67D] to-[#CD7F32] text-[#1E3A5F] px-12 py-5 rounded-full font-bold text-lg btn-modern"
              data-testid="final-cta-primary"
            >
              Je réserve ma place
            </button>
            <button 
              onClick={redirectToInscription}
              className="border border-white/50 text-white px-12 py-5 rounded-full font-semibold text-lg hover:bg-white/10 transition-all"
              data-testid="final-cta-secondary"
            >
              Télécharger le dossier
            </button>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

const AgencySection = () => {
  return (
    <section className="py-16 bg-[#FAFAF8]" data-testid="agency-section">
      <div className="max-w-4xl mx-auto px-6">
        <div className="bg-white rounded-2xl p-8 md:p-10 text-center shadow-lg border border-[#1E3A5F]/10">
          <Ship className="w-12 h-12 text-[#C9A962] mx-auto mb-4" />
          <h3 className="text-2xl font-bold text-[#1E3A5F] mb-4">Organisation & cadre légal</h3>
          <p className="text-[#1E3A5F]/70">
            Voyage organisé en collaboration avec notre agence <strong>VOYAGES COUTURE</strong>, 
            immatriculée Atout France n° <strong>75100088</strong> — Garantie financière <strong>Atradius</strong>.
          </p>
        </div>
      </div>
    </section>
  );
};

const Footer = () => {
  return (
    <footer className="bg-[#1E3A5F] text-white py-16" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <Waves className="w-8 h-8 text-[#C9A962]" />
              <span className="font-['Playfair_Display'] text-xl font-semibold">Sataya 2026</span>
            </div>
            <p className="text-white/70 text-sm leading-relaxed">
              Voyage initiatique en communion avec les dauphins de la Mer Rouge. Une expérience transformatrice avec Gilles Delieuze.
            </p>
          </div>

          <div>
            <h4 className="text-[#C9A962] font-semibold mb-4">Navigation</h4>
            <ul className="space-y-2">
              {["Infos", "Programme", "Témoignages", "Tarifs", "FAQ"].map((link) => (
                <li key={link}>
                  <a href={`#${link.toLowerCase()}`} className="text-white/70 hover:text-[#C9A962] transition-colors text-sm">
                    {link}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-[#C9A962] font-semibold mb-4">Légal</h4>
            <ul className="space-y-2">
              {["Mentions légales", "CGV", "Politique de confidentialité", "Cookies"].map((link) => (
                <li key={link}>
                  <a href="#" className="text-white/70 hover:text-[#C9A962] transition-colors text-sm">
                    {link}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-[#C9A962] font-semibold mb-4">Contact</h4>
            <ul className="space-y-3">
              <li>
                <a href="mailto:contact@gillesdelieuze.com" className="text-white/70 hover:text-[#C9A962] transition-colors text-sm flex items-center gap-2">
                  <Mail className="w-4 h-4" />
                  contact@gillesdelieuze.com
                </a>
              </li>
              <li>
                <a href="https://gillesdelieuze.com" target="_blank" rel="noopener noreferrer" className="text-white/70 hover:text-[#C9A962] transition-colors text-sm flex items-center gap-2">
                  <ExternalLink className="w-4 h-4" />
                  gillesdelieuze.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 text-center">
          <p className="text-white/50 text-sm mb-2">© 2026 Gilles Delieuze - Tous droits réservés</p>
          <p className="text-white/40 text-xs">Voyage organisé en partenariat avec Voyages Couture (Atout France n°75100088)</p>
        </div>
      </div>
    </footer>
  );
};

const ContactModal = ({ isOpen, onClose }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    interest: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      await axios.post(`${API_URL}/leads`, formData);
      toast.success("Merci ! Vous recevrez toutes les informations par email très prochainement.");
      onClose();
      setFormData({ name: '', email: '', phone: '', interest: '', message: '' });
    } catch (error) {
      console.error('Error submitting form:', error);
      toast.error("Une erreur est survenue. Veuillez réessayer.");
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!isOpen) return null;

  return (
    <AnimatePresence>
      <motion.div 
        className="fixed inset-0 bg-[#1E3A5F]/90 backdrop-blur-lg z-[1000] flex items-center justify-center p-4"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        onClick={onClose}
        data-testid="contact-modal"
      >
        <motion.div 
          className="bg-white rounded-3xl p-8 md:p-12 max-w-lg w-full max-h-[90vh] overflow-y-auto relative shadow-2xl"
          initial={{ scale: 0.95, y: 20 }}
          animate={{ scale: 1, y: 0 }}
          exit={{ scale: 0.95, y: 20 }}
          onClick={(e) => e.stopPropagation()}
        >
          <button 
            onClick={onClose}
            className="absolute top-6 right-6 w-10 h-10 rounded-full bg-[#FAFAF8] flex items-center justify-center hover:bg-[#1E3A5F] hover:text-white transition-all group"
            data-testid="modal-close"
          >
            <X className="w-5 h-5" />
          </button>

          <h2 className="text-3xl font-bold text-[#1E3A5F] mb-2">Restons en contact</h2>
          <p className="text-[#1E3A5F]/60 mb-8">Remplissez ce formulaire et recevez toutes les informations par email.</p>

          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <label className="block text-sm font-semibold text-[#1E3A5F] mb-2">Nom & Prénom *</label>
              <input 
                type="text"
                required
                value={formData.name}
                onChange={(e) => setFormData({...formData, name: e.target.value})}
                className="w-full px-4 py-3 rounded-xl border border-[#1E3A5F]/20 focus:border-[#C9A962] focus:outline-none focus:ring-2 focus:ring-[#C9A962]/20 transition-all bg-[#FAFAF8]"
                data-testid="form-name"
              />
            </div>

            <div>
              <label className="block text-sm font-semibold text-[#1E3A5F] mb-2">Email *</label>
              <input 
                type="email"
                required
                value={formData.email}
                onChange={(e) => setFormData({...formData, email: e.target.value})}
                className="w-full px-4 py-3 rounded-xl border border-[#1E3A5F]/20 focus:border-[#C9A962] focus:outline-none focus:ring-2 focus:ring-[#C9A962]/20 transition-all bg-[#FAFAF8]"
                data-testid="form-email"
              />
            </div>

            <div>
              <label className="block text-sm font-semibold text-[#1E3A5F] mb-2">Téléphone *</label>
              <input 
                type="tel"
                required
                value={formData.phone}
                onChange={(e) => setFormData({...formData, phone: e.target.value})}
                className="w-full px-4 py-3 rounded-xl border border-[#1E3A5F]/20 focus:border-[#C9A962] focus:outline-none focus:ring-2 focus:ring-[#C9A962]/20 transition-all bg-[#FAFAF8]"
                data-testid="form-phone"
              />
            </div>

            <div>
              <label className="block text-sm font-semibold text-[#1E3A5F] mb-2">Que souhaitez-vous ? *</label>
              <select 
                required
                value={formData.interest}
                onChange={(e) => setFormData({...formData, interest: e.target.value})}
                className="w-full px-4 py-3 rounded-xl border border-[#1E3A5F]/20 focus:border-[#C9A962] focus:outline-none focus:ring-2 focus:ring-[#C9A962]/20 transition-all bg-[#FAFAF8]"
                data-testid="form-interest"
              >
                <option value="">Sélectionnez une option</option>
                <option value="dossier">Recevoir le dossier complet PDF</option>
                <option value="reservation">Réserver ma place</option>
                <option value="info">Obtenir plus d'informations</option>
                <option value="appel">Être rappelé(e)</option>
              </select>
            </div>

            <div>
              <label className="block text-sm font-semibold text-[#1E3A5F] mb-2">Message (optionnel)</label>
              <textarea 
                value={formData.message}
                onChange={(e) => setFormData({...formData, message: e.target.value})}
                rows={4}
                placeholder="Questions, besoins particuliers..."
                className="w-full px-4 py-3 rounded-xl border border-[#1E3A5F]/20 focus:border-[#C9A962] focus:outline-none focus:ring-2 focus:ring-[#C9A962]/20 transition-all bg-[#FAFAF8] resize-none"
                data-testid="form-message"
              />
            </div>

            <button 
              type="submit"
              disabled={isSubmitting}
              className="w-full bg-gradient-to-r from-[#C9A962] via-[#DCC67D] to-[#CD7F32] text-[#1E3A5F] py-4 rounded-full font-bold text-lg transition-all disabled:opacity-50 disabled:cursor-not-allowed btn-modern"
              data-testid="form-submit"
            >
              {isSubmitting ? "Envoi en cours..." : "Envoyer ma demande"}
            </button>
          </form>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};

// Main Landing Page Component
const LandingPage = () => {
  const [scrolled, setScrolled] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 100);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen" data-testid="landing-page">
      <Navigation scrolled={scrolled} />
      <HeroSection />
      <StatsBar />
      <InfosSection />
      <PillarsSection />
      <StorySection />
      <DestinationSection />
      <EthicalSection />
      <ProgrammeSection />
      <BoatSection />
      <TestimonialsSection />
      <GallerySection />
      <PDFViewerSection />
      <PricingSection />
      <InclusionSection />
      <FAQSection />
      <GillesSection />
      <FinalCTASection />
      <AgencySection />
      <Footer />
      <ContactModal isOpen={modalOpen} onClose={() => setModalOpen(false)} />
    </div>
  );
};

export default LandingPage;
